'use strict';

require('bootstrap/js/src/util');

require('bootstrap/js/src/collapse');


// WEBPACK FOOTER //
// ./scripts/bootstrapped.js